/**
 * Endereços e constantes de sintonia da camada de voz.
 *
 * Os caminhos são relativos de propósito. O ADR-008 fixou um domínio só: o
 * front, a API e o TTS compartilham origem, então caminho relativo funciona em
 * produção e, no `vite dev`, cai no proxy já configurado para `/v1/u1`. Base
 * absoluta em constante seria a mesma armadilha do `api.willone.com.br` que o
 * ADR-008 removeu.
 */

/** ADR-008 — a API do U1 vive em rota do próprio willone.com.br. */
export const U1_API_PATH = '/v1/u1';

/** OmniVoice: serviço próprio, já no ar, devolve audio/ogg binário. */
export const TTS_URL = '/api/tts';

/**
 * Negociação WebRTC do Realtime. O SDP offer vai para o nosso servidor, que
 * faz a troca com a OpenAI — a chave nunca desce para o navegador.
 */
export const REALTIME_CALLS_URL = `${U1_API_PATH}/realtime/calls`;

export const DEFAULT_LANGUAGE = 'pt-BR';

/** A voz do Diego (ADR-007), usada no modo `hybrid`. */
export const DEFAULT_OMNIVOICE_VOICE = 'diego-objecoes';

export const DEFAULT_REALTIME_MODEL = 'gpt-realtime-2.1';

/** Só usada no modo `realtime`, quando o Diego sai de cena. */
export const DEFAULT_REALTIME_VOICE = 'marin';

/**
 * Fim de turno com espera variável.
 *
 * 700 ms é o silêncio que separa "terminei de falar" de "estou respirando".
 * Quando a última palavra é de ligação a frase está visivelmente incompleta,
 * e cortar ali produz o pior defeito de conversa por voz: o assistente
 * respondendo a meia pergunta. 1400 ms compra a pausa de quem está pensando
 * no meio da frase.
 */
export const ESPERA_FIM_DE_TURNO_MS = 700;
export const ESPERA_APOS_CONECTIVO_MS = 1400;

/** Tempo máximo esperando o ICE fechar antes de mandar o offer assim mesmo. */
export const ICE_TIMEOUT_MS = 1500;
